@if (items?.length) {
    <div class="max-h-[500px] overflow-y-auto pe-2">
        <div class="relative">
            <div class="flex flex-col gap-0">
                @for (
                    item of items;
                    track trackByIndex($index, item);
                    let isFirst = $first;
                    let isLast = $last
                ) {
                    <div class="relative flex gap-4">
                        <!-- Content Card -->
                        <div class="flex-1 pb-6" [ngClass]="{ 'pb-0': isLast }">
                            <div
                                class="rounded-xl border border-slate-200 bg-white p-4 transition-shadow hover:shadow-sm"
                            >
                                <!-- Header: User + Timestamp -->
                                <div
                                    class="flex flex-wrap items-start justify-between gap-2"
                                >
                                    <div
                                        class="flex flex-wrap items-center gap-1.5 text-xs text-slate-500"
                                    >
                                        <i
                                            class="fa-light fa-user text-slate-400"
                                        ></i>
                                        @if (item.user) {
                                            <span>
                                                <app-user-link
                                                    [item]="item.user"
                                                ></app-user-link>
                                            </span>
                                        } @else {
                                            -
                                        }
                                    </div>
                                    <span class="text-xs text-slate-400">
                                        {{
                                            item.creationTime
                                                | date: 'yyyy-MM-dd hh:mm a'
                                        }}
                                    </span>
                                </div>
                                <!-- Result Analysis Fields -->
                                @if (type === 'result-analysis') {
                                    <div class="mt-3 flex flex-col gap-3">
                                        <!-- Arabic -->
                                        <div class="flex flex-col gap-1.5">
                                            <span
                                                class="text-sm font-semibold text-slate-800"
                                            >
                                                {{
                                                    'translate_result_analysis_in_arabic'
                                                        | translate
                                                }}
                                            </span>
                                            <div
                                                class="flex flex-wrap items-center gap-2 text-sm"
                                            >
                                                @if (item.lastValueAr) {
                                                    <span
                                                        class="whitespace-normal break-words text-slate-400 line-through"
                                                    >
                                                        {{ item.lastValueAr }}
                                                    </span>
                                                }
                                                @if (item.lastValueAr) {
                                                    <i
                                                        class="fa-light fa-arrow-left ltr:fa-arrow-right shrink-0 text-xs text-slate-300"
                                                    ></i>
                                                }
                                                <span
                                                    class="whitespace-normal break-words"
                                                    [ngClass]="{
                                                        'font-medium text-slate-800':
                                                            item.lastValueAr,
                                                        'text-slate-700':
                                                            !item.lastValueAr,
                                                    }"
                                                >
                                                    {{
                                                        item.currentValueAr ||
                                                            '-'
                                                    }}
                                                </span>
                                            </div>
                                        </div>
                                        <!-- English -->
                                        <div class="flex flex-col gap-1.5">
                                            <span
                                                class="text-sm font-semibold text-slate-800"
                                            >
                                                {{
                                                    'translate_result_analysis_in_english'
                                                        | translate
                                                }}
                                            </span>
                                            <div
                                                class="flex flex-wrap items-center gap-2 text-sm"
                                            >
                                                @if (item.lastValueEn) {
                                                    <span
                                                        class="whitespace-normal break-words text-slate-400 line-through"
                                                    >
                                                        {{ item.lastValueEn }}
                                                    </span>
                                                }
                                                @if (item.lastValueEn) {
                                                    <i
                                                        class="fa-light fa-arrow-left ltr:fa-arrow-right shrink-0 text-xs text-slate-300"
                                                    ></i>
                                                }
                                                <span
                                                    class="whitespace-normal break-words"
                                                    [ngClass]="{
                                                        'font-medium text-slate-800':
                                                            item.lastValueEn,
                                                        'text-slate-700':
                                                            !item.lastValueEn,
                                                    }"
                                                >
                                                    {{
                                                        item.currentValueEn ||
                                                            '-'
                                                    }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <!-- Improvement Procedure Fields -->
                                @if (type === 'improvement-procedure') {
                                    <div class="mt-3 flex flex-col gap-3">
                                        <!-- Arabic Description -->
                                        <div class="flex flex-col gap-1.5">
                                            <span
                                                class="text-sm font-semibold text-slate-800"
                                            >
                                                {{
                                                    'translate_improvement_procedures_description_in_arabic'
                                                        | translate
                                                }}
                                            </span>
                                            <div
                                                class="flex flex-wrap items-center gap-2 text-sm"
                                            >
                                                @if (item.lastValueAr) {
                                                    <span
                                                        class="whitespace-normal break-words text-slate-400 line-through"
                                                    >
                                                        {{ item.lastValueAr }}
                                                    </span>
                                                }
                                                @if (item.lastValueAr) {
                                                    <i
                                                        class="fa-light fa-arrow-left ltr:fa-arrow-right shrink-0 text-xs text-slate-300"
                                                    ></i>
                                                }
                                                <span
                                                    class="whitespace-normal break-words"
                                                    [ngClass]="{
                                                        'font-medium text-slate-800':
                                                            item.lastValueAr,
                                                        'text-slate-700':
                                                            !item.lastValueAr,
                                                    }"
                                                >
                                                    {{
                                                        item.currentValueAr ||
                                                            '-'
                                                    }}
                                                </span>
                                            </div>
                                        </div>
                                        <!-- English Description -->
                                        <div class="flex flex-col gap-1.5">
                                            <span
                                                class="text-sm font-semibold text-slate-800"
                                            >
                                                {{
                                                    'translate_improvement_procedures_description_in_english'
                                                        | translate
                                                }}
                                            </span>
                                            <div
                                                class="flex flex-wrap items-center gap-2 text-sm"
                                            >
                                                @if (item.lastValueEn) {
                                                    <span
                                                        class="whitespace-normal break-words text-slate-400 line-through"
                                                    >
                                                        {{ item.lastValueEn }}
                                                    </span>
                                                }
                                                @if (item.lastValueEn) {
                                                    <i
                                                        class="fa-light fa-arrow-left ltr:fa-arrow-right shrink-0 text-xs text-slate-300"
                                                    ></i>
                                                }
                                                <span
                                                    class="whitespace-normal break-words"
                                                    [ngClass]="{
                                                        'font-medium text-slate-800':
                                                            item.lastValueEn,
                                                        'text-slate-700':
                                                            !item.lastValueEn,
                                                    }"
                                                >
                                                    {{
                                                        item.currentValueEn ||
                                                            '-'
                                                    }}
                                                </span>
                                            </div>
                                        </div>
                                        <!-- Completion Percentage -->
                                        <div class="flex flex-col gap-1.5">
                                            <span
                                                class="text-sm font-semibold text-slate-800"
                                            >
                                                {{
                                                    'translate_completion_percentage'
                                                        | translate
                                                }}
                                            </span>
                                            <div
                                                class="flex flex-wrap items-center gap-2 text-sm"
                                            >
                                                @if (
                                                    item.lastCompletionPercentage !==
                                                        null &&
                                                    item.lastCompletionPercentage !==
                                                        ''
                                                ) {
                                                    <span
                                                        class="text-slate-400 line-through"
                                                    >
                                                        {{
                                                            item.lastCompletionPercentage +
                                                                '%'
                                                        }}
                                                    </span>
                                                }
                                                @if (
                                                    item.lastCompletionPercentage !==
                                                        null &&
                                                    item.lastCompletionPercentage !==
                                                        ''
                                                ) {
                                                    <i
                                                        class="fa-light fa-arrow-left ltr:fa-arrow-right shrink-0 text-xs text-slate-300"
                                                    ></i>
                                                }
                                                <span
                                                    [ngClass]="{
                                                        'font-medium text-slate-800':
                                                            item.lastCompletionPercentage !==
                                                                null &&
                                                            item.lastCompletionPercentage !==
                                                                '',
                                                        'text-slate-700':
                                                            item.lastCompletionPercentage ===
                                                                null ||
                                                            item.lastCompletionPercentage ===
                                                                '',
                                                    }"
                                                >
                                                    {{
                                                        item.currentCompletionPercentage !==
                                                            null &&
                                                        item.currentCompletionPercentage !==
                                                            ''
                                                            ? item.currentCompletionPercentage +
                                                              '%'
                                                            : '-'
                                                    }}
                                                </span>
                                            </div>
                                        </div>
                                        <!-- Expected Completion Date -->
                                        <div class="flex flex-col gap-1.5">
                                            <span
                                                class="text-sm font-semibold text-slate-800"
                                            >
                                                {{
                                                    'translate_expected_completion_date'
                                                        | translate
                                                }}
                                            </span>
                                            <div
                                                class="flex flex-wrap items-center gap-2 text-sm"
                                            >
                                                @if (
                                                    item.lastExpectedCompletionDate
                                                ) {
                                                    <span
                                                        class="text-slate-400 line-through"
                                                    >
                                                        {{
                                                            item.lastExpectedCompletionDate
                                                                | date
                                                                    : 'yyyy-MM-dd'
                                                        }}
                                                    </span>
                                                }
                                                @if (
                                                    item.lastExpectedCompletionDate
                                                ) {
                                                    <i
                                                        class="fa-light fa-arrow-left ltr:fa-arrow-right shrink-0 text-xs text-slate-300"
                                                    ></i>
                                                }
                                                <span
                                                    [ngClass]="{
                                                        'font-medium text-slate-800':
                                                            item.lastExpectedCompletionDate,
                                                        'text-slate-700':
                                                            !item.lastExpectedCompletionDate,
                                                    }"
                                                >
                                                    {{
                                                        item.currentExpectedCompletionDate
                                                            ? (item.currentExpectedCompletionDate
                                                              | date
                                                                  : 'yyyy-MM-dd')
                                                            : '-'
                                                    }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
} @else {
    <div class="py-8 text-center text-sm text-slate-500">
        {{ 'translate_no_data_available' | translate }}
    </div>
}
